import { useContext, useEffect } from 'react';
import { EstimateContext } from '@src/contexts/EstimateContext';

import { useAiAssistant } from './AiAssistantContext';
import { useIsAiAssistantEnabled } from './hooks/useIsAiAssistantEnabled';

// Rendered inside the estimate route's <EstimateContextProvider> so it can read
// the live estimate and push its id up to the globally-mounted assistant. Only
// the id is sent — the AI service fetches (and caches) the full estimate from the
// backend. Renders nothing; clears the snapshot when the estimate page unmounts.
export function AiAssistantEstimateContextBridge() {
  const estimate = useContext(EstimateContext);
  const { setEstimateSnapshot } = useAiAssistant();
  const isAiAssistantEnabled = useIsAiAssistantEnabled();
  const estimateId = estimate?.inputs?.id;

  useEffect(() => {
    if (!isAiAssistantEnabled) {
      return undefined;
    }
    setEstimateSnapshot(estimateId ? { estimateId } : null);
    return () => setEstimateSnapshot(null);
  }, [isAiAssistantEnabled, estimateId, setEstimateSnapshot]);

  return null;
}
